/**
 * Map of available hubs
 */
export const hubs = {
  liveHub: 'liveHubCompressed',
  liveDetailsHub: 'liveHubLiveCompressed',
  notificationHub: 'notificationHub',
  cashoutHub: 'cashoutHub',
  liveStatisticsHub: 'liveMatchStatisticsHub',
  // jackpotHub: 'jackpotHub',
  // viewBetSlipsHub: 'viewBetSlipsHub',
  // authorizationBetslipsHub: 'authorizationBetslipsHub',
  // evaluateBetSlipsHub: 'evaluateBetSlipsHub',
  // searchBetSlipsHub: 'searchBetSlipsHub',
};

export const hubConnections = [
  hubs.liveHub,
  hubs.liveDetailsHub,
  hubs.notificationHub,
  hubs.cashoutHub,
  hubs.liveStatisticsHub,
];

/**
 * Map of hub connections -> available hub connection methods
 */
export const hubsProxyMethods = {
  [hubs.notificationHub]: {
    connect: 'connect',
  },
  [hubs.liveDetailsHub]: {
    connectMatchDetails: 'connectMatchDetails',
    disconnect: 'disconnect',
    cangeMatchOnClick: 'cangeMatchOnClick',
  },
  [hubs.liveHub]: {
    connect: 'Connect',
    disconnect: 'Disconnect',
  },
  [hubs.cashoutHub]: {
    connect: 'connectMyBets',
    startCalculation: 'startCalculation',
    stopCalculation:'stopCalculation'
    // connectHistory: 'connectHistory',
    // disconnectHistory: 'disconnectHistory',
  },
  [hubs.liveStatisticsHub]: {
    connect: 'connect',
    disconnect: 'disconnect',
  },
  // [hubs.viewBetSlipsHub]: {
  //   connect: 'connect',
  // },
  // [hubs.jackpotHub]: {
  //   connect: 'connect',
  //   disconnect: 'disconnect',
  //   connectJackpotSearch: 'connectJackpotSearch',
  // },
  // [hubs.authorizationBetslipsHub]: {
  //   connect: 'connect',
  //   disconnect: 'disconnect',
  //   refreshAuthorization: 'refreshAuthorization',
  //   connectAuthorize: 'connectAuthorize',
  //   disconnectAuthorize: 'disconnectAuthorize',
  //   getOnlineAdmins: 'getOnlineAdmins',
  // },
  // [hubs.evaluateBetSlipsHub]: {
  //   connect: 'connectEvaluate',
  //   disconnect: 'disconnectEvaluate',
  // },
  // [hubs.searchBetSlipsHub]: {
  //   connect: 'connect',
  //   disconnect: 'disconnect',
  // },
};
